import React, {FC, memo} from 'react';
import LegalDocument from '@/app/components/legal_document/widget';

const TermsOfService: FC = () => {
  return <LegalDocument documentType="termsOfService" />;
};

export default memo(TermsOfService);